import client from "./baseApi";
import appconfig from '../config/appconfig';
//used
const cp_menus=async ()=>{   
    const cp_menus = await fetch(appconfig.baseurl+'/sponsor/v2/master/admin_panel_menus',{	
            headers: {"apikey":'8c730766-7cf4-4997-8cf4-be9023483518',
            'Content-Type': 'application/json'},
            method:'GET'            
          });
    return cp_menus
}

const getUsersList = (params) => client.get("/sponsor/v2/sponsor/getUsersList", params)
const addUsers = (data) => client.post("/sponsor/v2/sponsor/addUsers", data);
const deleteUser = (data) => client.post("/sponsor/v2/sponsor/deleteUser", data);
const admin_panel_roles = (params) => client.get("/sponsor/v2/master/admin_panel_roles", params)
const add_admin_panel_roles=(params) => client.post("/sponsor/v2/master/add_admin_panel_roles", params)
const delete_admin_panel_roles=(params) => client.post("/sponsor/v2/master/delete_admin_panel_roles", params)


const admin_panel_menus=(params) => client.get("/sponsor/v2/master/admin_panel_menus", params)
const add_admin_panel_menus=(params) => client.post("/sponsor/v2/master/add_admin_panel_menus", params)
const delete_admin_panel_menus=(params) => client.post("/sponsor/v2/master/delete_admin_panel_menus", params)


const getLocation = (params) => client.get("/sponsor/v2/master/getLocation", params)
const getGroup = (params) => client.get("/sponsor/v2/master/getGroup", params)
const getCocernMasterList = (params) => client.get("/sponsor/v2/master/ConcernMaster", params)
const getContextMasterList = (params) => client.get("/sponsor/v2/master/ContextMaster", params)
const getReason=(params) => client.get("/sponsor/v2/master/getReason", params)
const getCallDispositionType=(params) => client.get("/sponsor/v2/master/getCallDispositionType", params)
const getExperties=(params) => client.get("/sponsor/v2/master/getExperties", params)

export default {getUsersList,addUsers,deleteUser,cp_menus,admin_panel_roles,
  admin_panel_menus,add_admin_panel_menus,add_admin_panel_roles,delete_admin_panel_roles,
  delete_admin_panel_menus,getLocation,getGroup,getCocernMasterList,getContextMasterList,getReason,getCallDispositionType,getExperties};


